import { TransitionLinkV2 } from "@/src/common/TransitionLinkV2";
import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";
import { FlyerEventType, TelemetryEntity } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import { type PropsWithStyleX, type QuerySmMax, type QueryXsMax, colors } from "../../styles/tokens.stylex";

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    mostPopularFlyersItem: {
        display: "flex",
        flexDirection: "column",

        height: {
            default: "390px",
            [smMax]: "290px",
            [xsMax]: "calc(0.7 * (100vw - 50px))",
        },
    },
    wrapper: {
        borderColor: colors.b_centas,
        borderRadius: "5px",
        borderStyle: "solid",
        borderWidth: "1px",
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        width: "100%",
    },
    flyerImage: {
        overflow: "hidden",
        objectFit: "contain",
        height: "80%",
    },
    brandImage: {
        paddingBlock: "5px",
        paddingInline: "0",
        aspectRatio: "1/1",
        objectFit: "contain",
        height: "20%",
    },
});

export type IMostPopularFlyersItem = PropsWithStyleX & {
    brandLogo: IImageLoader;
    flyerImage: IImageLoader;
    link: string;
    brandId: string;
    isNewFlyer: boolean;
    alt: string;
};

export const MostPopularFlyersItem = (props: IMostPopularFlyersItem) => (
    <TransitionLinkV2
        href={props.link}
        telemetryCustom={{
            eventName: `${TelemetryEntity.FlyerDetails}-${FlyerEventType.flyerPagesClick}`,
            actionType: "Undefined",
            itemId: props.brandId,
            param1: props.isNewFlyer ? "NewFlyer" : undefined,
            origin: "FlyersWorld",
        }}
        styleX={[styles.mostPopularFlyersItem, styles.wrapper, props.styleX]}
    >
        <ImageLoader {...props.flyerImage} {...stylex.props(styles.flyerImage)} alt={props.alt} size={300} />
        <ImageLoader {...props.brandLogo} {...stylex.props(styles.brandImage)} size={300} />
    </TransitionLinkV2>
);
